import { render, staticRenderFns } from "./ysw.vue?vue&type=template&id=4d82ea31&scoped=true&"
import script from "./ysw.vue?vue&type=script&lang=js&"
export * from "./ysw.vue?vue&type=script&lang=js&"
import style0 from "./ysw.vue?vue&type=style&index=0&id=4d82ea31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82ea31",
  null
  
)

export default component.exports